/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
/* eslint-disable no-unused-vars */
import {FunctionComponent, useEffect, useState} from 'react';
import {IconProps, IconSize} from '../types/types';

/**
 * Defines the useIconSize hook which returns the icon color and size based
 * on the provided default values, if any.
 *
 * ```typescript
 *   import {useIconSize} from '@ion/dls/src/icons/useIconSize';
 *
 *   export const Icon = ({size}: IconProps) => {
 *     const iconSize = useIconSize(size);
 *     return (
 *       <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
 *        ...
 *       </svg>
 *     );
 *   };
 *
 * ```
 */
export const useIconSize = (size: IconSize = IconSize.medium) => {
  const [iconSize, setIconSize] = useState(size);
  useEffect(() => {
    setIconSize(size);
  }, [size]);
  return iconSize;
};
export default useIconSize;
